module.exports = {"data":{"site":{"siteMetadata":{"title":"Blog by George Montgomery","siteTwitterUrl":"https://twitter.com/Adverbly_","siteLinkedInUrl":"https://www.linkedin.com/in/montgomerygeorge","siteGithubUrl":"https://github.com/Adverbly/Adverbly.github.io","siteEmailUrl":"mailto:george.p.montgomery@gmail.com"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 109
// module chunks = 60335399758886 114276838955818